module.exports = __webpack_public_path__ + "static/logo-marker.4ac682a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-marker.png
// module id = 1874
// module chunks = 186072240823722